import comp from "./SubjectGroupWithSubjectView";
export default comp;
